import React, {Component} from "react"
import {connect} from "react-redux"
import {translate} from "react-i18next"

import {Container, Row, Col} from "../Grid"
import {AppCreators} from "../../containers/App/redux"

import Start from "./Start"
import Single from "./Single"
import Multiple from "./Multiple"
import TrueFalse from "./TrueFalse"
import Order from "./Order"
import Assign from "./Assign"
import Finish from "./Finish"

import styles from "./styles.css"

import api from "../../services/ApiService"
import {log} from "../../utils"

class Quiz extends Component {
  constructor() {
    super()

    this.handleNext = this.handleNext.bind(this)
    this.markAsDone = this.markAsDone.bind(this)
    this.restartQuiz = this.restartQuiz.bind(this)
    this.closeQuiz = this.closeQuiz.bind(this)
    this.renderSteps = this.renderSteps.bind(this)
    this.maybeTrackResponse = this.maybeTrackResponse.bind(this)

    this.initialState = this.state = {
      currentQuestion: "",
      fails: 0,
      currentQuiz: 0,
      doneSuccess: false,
      quizCompleted: false
    }
  }

  componentDidMount() {
    if (!this.props.fetching) {
      this.setState({
        currentQuestion: this.props.questions.questions[0].type
      })

      // tracking
      this.props.addTracking({
        event: "mtm.startQuiz",
        quiz_name: this.props.quizname
      })
    }
  }
  componentDidUpdate(prevProps, _prevState) {
    if (prevProps.questions !== this.props.questions && !this.props.fetching) {
      this.setState({
        currentQuestion: this.props.questions.questions[0].type
      })
    }
  }

  closeQuiz(success) {
    this.props.closeQuiz(success)

    if (!success) {
      this.restartQuiz()
    }
  }

  renderQuiz(type) {
    const childProps = {
      ...this.props,
      handleNext: this.handleNext,
      fails: this.state.fails,
      currentQuiz: this.state.currentQuiz
    }
    const finishProps = {
      ...this.props,
      fails: this.state.fails,
      markAsDone: this.markAsDone,
      restartQuiz: this.restartQuiz,
      closeQuiz: this.closeQuiz
    }
    switch (type) {
      case "start":
        return <Start {...childProps} />
      case "single_choice":
        return <Single {...childProps} />
      case "multiple_choice":
        return <Multiple {...childProps} />
      case "true_false":
        return <TrueFalse {...childProps} />
      case "order":
        return <Order {...childProps} key={this.state.currentQuiz} />
      case "assign":
        return <Assign {...childProps} key={this.state.currentQuiz} />
      case "finish":
        return <Finish {...finishProps} />
      default:
        return <Start {...childProps} />
    }
  }

  handleNext(isFailed, fails) {
    if (fails) {
      this.setState({
        fails: fails
      })
    }
    if (isFailed) {
      this.setState({
        currentQuestion: "finish"
      })
    } else {
      if (
        this.state.currentQuiz + 1 !==
        this.props.questions.questions.length
      ) {
        this.setState({
          currentQuiz: this.state.currentQuiz + 1,
          currentQuestion: this.props.questions.questions[
            this.state.currentQuiz + 1
          ].type
        })
      } else {
        this.setState({
          currentQuestion: "finish"
        })
      }
    }
  }

  async markAsDone(success) {
    this.setState({
      quizCompleted: true
    })

    // general tracking
    this.props.addTracking({
      event: "mtm.finishQuiz",
      quiz_result: success ? "success" : "fail",
      quiz_name: this.props.quizname
    })

    if (success) {
      this.setState({
        doneSuccess: true
      })

      try {
        const response = await api.markLearningArticleAsRead(
          this.props.postID,
          this.props.lang
        )

        this.maybeTrackResponse(response)
      } catch (e) {
        log.dir(e)
      }
    }
  }

  restartQuiz() {
    // reset css classes
    for (
      var i = 0;
      i < document.querySelectorAll(".quiz-steps li").length;
      i++
    ) {
      document.querySelectorAll(".quiz-steps li")[i].classList.remove("active")
    }

    // set initial state after animation
    // set first question as current question type to skip start screen
    const _self = this
    setTimeout(function() {
      _self.setState({
        ..._self.initialState,
        currentQuestion: _self.props.questions.questions[0].type
      })
    }, 250)

    // tracking
    this.props.addTracking({
      event: "mtm.restartQuiz",
      quiz_name: this.props.quizname
    })
  }

  renderSteps(item, key) {
    let index = key + 1
    return (
      <li key={key} className={item.type}>
        {index}
      </li>
    )
  }

  maybeTrackResponse(resp) {
    if (resp.status === "success") {
      // article
      this.props.addTracking({
        event: "mtm.finishedSection",
        section_finished: "article"
      })

      // module
      if (resp.completed_module) {
        this.props.addTracking({
          event: "mtm.finishedSection",
          section_finished: "module"
        })
      }

      // topic
      if (resp.completed_topic) {
        this.props.addTracking({
          event: "mtm.finishedSection",
          section_finished: "course"
        })
      }
    }
  }

  render() {
    const {modulename, quizname, questions, questionslength, t} = this.props
    const {currentQuiz} = this.state
    const currentFailPercantage = Math.floor(
      (this.state.fails * 100) / questionslength
    )

    let amountOfPossibleFails = Math.ceil(questionslength * window.DP_ENV.QUIZ_MAX_FAILURES) + 1
    amountOfPossibleFails = amountOfPossibleFails - this.state.fails

    return (
      <div className={styles.Quiz}>
        <div className="inner">
          <div className="header">
            <Container>
              <Row>
                <Col className="modal-title" md={1} size={6}>
                  <span className="modulename">{modulename}</span>
                  <i className="icon icon-next" />
                  <span className="quizname">{quizname}</span>
                  <span className="question">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t(
                          "Frage <b>{{question}}</b> von <b>{{questions}}</b>",
                          {
                            question: currentQuiz + 1,
                            questions: questions.questions.length
                          }
                        )
                      }}
                    />
                  </span>
                  {amountOfPossibleFails - 1 > 0 ? (
                    <span className="fails dynamic">
                      <i className="icon-like-filled" />
                      {amountOfPossibleFails - 1}
                    </span>
                  ) : (
                    <span className="fails static">
                      <i className="icon-like-filled" />0
                    </span>
                  )}
                </Col>
                <Col className="modal-close" md={1} size={6}>
                  <i
                    onClick={() => this.closeQuiz(false)}
                    className="icon icon-quiz-fail-box"
                  />
                </Col>
              </Row>
            </Container>
          </div>
          <div className="quiz-content">
            <div className={`quiz-steps length-${questionslength}`}>
              <Container>
                <Row>
                  <ul>
                    {questions.questions.map(this.renderSteps)}
                    {!this.state.quizCompleted ? (
                      <li className="last">
                        <i className="icon icon-quiz-1" />
                      </li>
                    ) : currentFailPercantage <= 30 ? (
                      <li className="last">
                        <i className="icon icon-quiz-2" />
                      </li>
                    ) : (
                      <li className="last">
                        <i className="icon icon-quiz-3" />
                      </li>
                    )}
                  </ul>
                </Row>
              </Container>
            </div>
            {!this.props.fetching
              ? this.renderQuiz(this.state.currentQuestion)
              : null}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang,
    avatar: state.login.avatar
  }
}
const mapDispatchToProps = dispatch => {
  return {
    addTracking: data => dispatch(AppCreators.trackingAdd(data))
  }
}

Quiz = connect(
  mapStateToProps,
  mapDispatchToProps
)(Quiz)
export default translate()(Quiz)



// WEBPACK FOOTER //
// ./src/components/Quiz/index.js